import React from 'react';
import { useTheme } from '../../../contexts/ThemeContext';
import SwimLaneTimeline, { TimelineLane } from '../../common/SwimLaneTimeline';

interface Props {
  workflowId: string;
  analytics: any;
}

const ExecutionTimeline: React.FC<Props> = ({ workflowId, analytics }) => {
  const { darkMode } = useTheme();

  const executions = analytics?.executions || [];

  if (executions.length === 0) {
    return (
      <div className={`p-8 text-center rounded-lg border ${darkMode ? 'border-gray-700 text-gray-500' : 'border-gray-200 text-gray-400'}`}>
        No executions recorded yet. Run this workflow to see the execution timeline.
      </div>
    );
  }

  // Build lanes from executions — each execution becomes a set of phase bars
  const lanes: TimelineLane[] = executions.slice(0, 10).map((ex: any, i: number) => ({
    id: ex.id || `ex-${i}`,
    label: `Run ${i + 1}`,
    color: ex.status === 'completed' ? '#22c55e' : ex.status === 'failed' ? '#ef4444' : '#f59e0b',
    events: (ex.phases || []).map((phase: any) => ({
      id: `${ex.id}-${phase.id}`,
      start: phase.start_time || ex.started_at || new Date().toISOString(),
      end: phase.end_time,
      label: phase.label || phase.id,
      status: phase.status === 'completed' ? 'success' as const
        : phase.status === 'failed' ? 'failure' as const
        : phase.status === 'in_progress' ? 'in_progress' as const
        : 'neutral' as const,
    })),
  }));

  return (
    <div className={`rounded-xl border p-4 ${darkMode ? 'bg-gray-800/50 border-gray-700' : 'bg-white border-gray-200'}`}>
      <div style={{ height: Math.max(lanes.length * 56 + 60, 200) }}>
        <SwimLaneTimeline lanes={lanes} />
      </div>
    </div>
  );
};

export default ExecutionTimeline;
